// api.js
import axios from 'axios';

// 创建 axios 实例
const apiClient = axios.create({
  baseURL: 'https://tk.botiku.com/api', // 生产环境地址
  timeout: 50000, // 请求超时时间
  withCredentials: true, // 允许跨域请求携带凭证
});

// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 从localStorage获取token并添加到请求头
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response;
  },
  (error) => {
    if (error.response) {
      // 请求已发出，但服务器响应状态码不在 2xx 范围内
      console.error('服务器响应错误:', error.response.status);
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error('请求未收到响应:', error.request);
    } else {
      // 在设置请求时发生了一些事情，触发了一个错误
      console.error('请求设置错误:', error.message);
    }
    return Promise.reject(error);
  }
);

// 封装 GET 请求
export const get = (url: string, params = {}) => {
  return apiClient.get(url, { params });
};

// 封装 POST 请求
export const post = (url: string, data = {}) => {
  return apiClient.post(url, data);
};

// 封装 PUT 请求
export const put = (url: string, data = {}) => {
  return apiClient.put(url, data);
};

// 封装 DELETE 请求
export const del = (url: string, params = {}) => {
  return apiClient.delete(url, { params });
};

// AI生成关键词接口
export const aiGenerateKeywords = (title: string) => {
  return apiClient.post('/aiGenerate/keywords', { title });
};

// 导出获取baseURL的函数
export const getBaseURL = () => {
  // 返回生产环境后端服务地址
  return 'https://tk.botiku.com/api';
};

// 获取图形验证码
export const getCaptcha = () => {
  return apiClient.get('/verificationCode/captcha', { responseType: 'blob' });
};

// 发送短信验证码
export const sendSms = (data: { mobile: string; verifyCode: string }) => {
  const formData = new FormData();
  formData.append('mobile', data.mobile);
  formData.append('verifyCode', data.verifyCode);
  return apiClient.post('/loginManage/sendSms', formData);
};

// 登录
export const login = (data: { mobile: string; smsCode: string }) => {
  const formData = new FormData();
  formData.append('mobile', data.mobile);
  formData.append('smsCode', data.smsCode);
  return apiClient.post('/loginManage/login', formData);
};

// 获取用户信息
export const getUser = () => {
  return apiClient.get('/loginManage/getUser');
};

// 退出登录
export const logout = () => {
  return apiClient.get('/loginManage/logout');
};

// 获取权益档位及折扣信息
export const getDiscountGear = () => {
  return apiClient.get('/loginManage/getDiscountGear');
};

// 获取用户当前档位
export const getUserDiscount = () => {
  return apiClient.get('/loginManage/getUserDiscount');
};

// 获取用户支付折扣信息
export const getUserDiscountByPay = () => {
  return apiClient.get('/loginManage/getUserDiscountByPay');
};

// 使用激活码支付
export const useActivationCode = (formData: FormData) => {
  return apiClient.post('/aiGenerate/useActivationCode', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// 获取用户历史订单信息
export const getOrderList = () => {
  return apiClient.get('/loginManage/getOrderList');
};